const IMG_URL_PREFIX = '//abres.octlib.com/commonImg/officialStore/';
const IMG_URL_PREFIX_DAMAI =
  '//cdnimages.awselbcombine.com/public_images/product_ext/';
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      picList: state => state.page.picList,
      gearList: state => state.page.gearList
    }),
    gameId() {
      return this.$store.state.gameId;
    },
    imgPrefix() {
      // 日本江美暂不支持后台上传商品图片
      return this.gameId == 2
        ? IMG_URL_PREFIX + 'beauty/'
        : IMG_URL_PREFIX_DAMAI + this.gameId + '/';
    },
    productDefaultIco() {
      return this.picList?.product1 || '';
    }
  },
  methods: {
    getGameIcon(icoName, trans = 0) {
      if (icoName && icoName.startsWith('http')) {
        return icoName;
      }
      // 如果没有传入图片名字，按照档位返回后台配置的默认图片
      if (!icoName) {
        if (!this.gearList.length) {
          return this.picList?.[`product1`];
        }
        for (let i = 0; i < this.gearList.length; i++) {
          const gear = this.gearList[i];
          if (+trans < +gear.min) {
            return this.picList?.[`product1`];
          } else if (+trans < +gear.max) {
            return this.picList?.[`product${i + 1}`];
          } else if (i === this.gearList.length - 1) {
            return this.picList?.[`product${this.gearList.length}`];
          }
        }
        return '';
      }
      return `${this.imgPrefix}${icoName}${
        /\.(png|jpe?g)$/.test(icoName) ? '' : '.png'
      }`;
    },
    handleImgError(e) {
      e.target.src = this.productDefaultIco;
    },
    loadImg(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve(url);
        };
        img.onerror = () => {
          reject();
        };
        img.src = url;
      });
    },
    // 江美特殊处理，它的商品名称是个图片，研发返回的图片名字大小写不一致，优先加载全小写的图片，加载失败再按原图片名字加载。
    getBeautyNameIco(nameIco, boolLowerCase = true) {
      if (!nameIco) {
        return;
      }
      return `${IMG_URL_PREFIX}beauty/name/${
        boolLowerCase ? nameIco.toLocaleLowerCase() : nameIco
      }`;
    },
    getBeautyProductIco(productIcon, boolLowerCase = true) {
      if (!productIcon) {
        return;
      }
      return `${IMG_URL_PREFIX}beauty/${
        boolLowerCase ? productIcon.toLocaleLowerCase() : productIcon
      }`;
    },
    beautyNameIcoError(e, nameIco) {
      // 先预加载图片，成功加载了才赋值，否则会无限循环触发error事件
      this.loadImg(this.getBeautyNameIco(nameIco, false)).then(src => {
        e.target.src = src;
      });
    },
    beautyProductIcoError(e, productIcon) {
      this.loadImg(this.getBeautyProductIco(productIcon, false)).then(src => {
        e.target.src = src;
      });
    }
  }
};
